import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";

function SearchOptArea(props: any) {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    get_list_by_ajax: (inData: any) => { },
    ...props
  };

  let listOpt = myProps.listOpt;

  const on_change_list_opt = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      ...inData
    };
    let name = opt_obj.name;
    let value = opt_obj.value;

    let change_list_opt = {
      ...listOpt,
    };
    change_list_opt[name] = value;
    myProps.setListOpt(change_list_opt);
  };

  const select_server_num_arr = [
    { value: "main", text: "메인서버" },
    { value: "main_user", text: "메인유저" },
    { value: "math", text: "수학" },
    { value: "coolen", text: "쿨영어" },
  ];

  return (
    <div>
      <div className="my_flex_left">
        <span>
          서버:
          <select className="search-input" name="server_num" value={listOpt.server_num}
            onChange={(e: any) => {
              on_change_list_opt({
                name: e.target.name,
                value: e.target.value
              });
            }}>
            {select_server_num_arr.map((item) => (
              <option key={item.value} value={item.value}>
                {item.text}
              </option>
            ))}
          </select>
        </span>
        <span>
          테이블:
          <input type="text" className="search-input" name="table" value={listOpt.table}
            autoComplete="off"
            onChange={(e: any) => {
              on_change_list_opt({
                name: e.target.name,
                value: e.target.value
              });
            }} />
        </span>
        <span>
          제한:
          <input type="text" className="search-input" name="limit_num" value={listOpt.limit_num}
            autoComplete="off"
            style={{ width: "100px", textAlign: "center" }}
            onChange={(e: any) => {
              on_change_list_opt({
                name: e.target.name,
                value: e.target.value
              });
            }} />
        </span>
        <span>
          <label>
            카운트:
            <input type="checkbox" name="is_count" checked={listOpt.is_count === "1"}
              autoComplete="off"
              onChange={(e: any) => {
                let is_check = e.target.checked;
                on_change_list_opt({
                  name: e.target.name,
                  value: is_check ? "1" : "0"
                });
              }} />
          </label>
        </span>
      </div>
      <div className="mt-1">
        GET:
        <input type="text" className="search-input" name="get_col" value={listOpt.get_col}
          autoComplete="off"
          style={{ width: "400px", textAlign: "center" }}
          onChange={(e: any) => {
            on_change_list_opt({
              name: e.target.name,
              value: e.target.value
            });
          }} />
      </div>
      <div className="mt-1">
        WHERE:
        <TextAreaComponent
          name="where_str"
          value={listOpt.where_str}
          style={{ width: "100%", minHeight: "60px" }}
          onChange={(e: any) => {
            on_change_list_opt({
              name: e.target.name,
              value: e.target.value
            });
          }}
        ></TextAreaComponent>
      </div>
      <div className="mt-1 text-center">
        <button className="btn-l btn-dark" onClick={() => {
          myProps.get_list_by_ajax({});
        }}>검색</button>
      </div>
    </div>
  );
};
export default SearchOptArea;